import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import SwitchField from '../../../../../helpers/Fields/SwitchField';
import TreeSelectField from '../../../../../helpers/Fields/TreeSelectField';
import { addValidator, required } from 'redux-form-validators';
import { getCardData, updateCard } from '../../../../actions';
import SelectFieldAnt from '../../../../../helpers/Fields/SelectFieldAnt';

export class FormContent extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
		super(props)
		this.state = {
			categories: [],
			subjects: [],
		}

		this.refEndEl = React.createRef();
	}
  
  submit = (data) => {
    console.log("🚀 ~ file: FormContent.jsx ~ line 26 ~ FormContent ~ data", data)
    this.props.updateCard({...data, is_deleted: false});
    this.props.handleClose()
  }

  async componentDidMount(){
    const res = await getCardData()
    console.log("🚀 ~ file: FormContent.jsx ~ line 19 ~ FormContent ~ componentDidMount ~ res", res)
    this.setState(res);
  }


  render() {
    const { handleSubmit, valuesForm } = this.props;
    const {formatMessage} = this.context;
    const { subjects, categories } = this.state;

    let tree = [];

    if(valuesForm && valuesForm.subject_id){
      categories.forEach(cat => {
        if(!cat.parent_id && cat.subject_id == valuesForm.subject_id){
          tree.push({
            title: cat.name,
            value: cat.id,
            children: []
          })
        }
      });
  
      categories.forEach(cat => {
        if(cat.parent_id && cat.subject_id == valuesForm.subject_id){
          tree.forEach(item => {
            if(item.value == cat.parent_id){
              item.children.push({
                title: cat.name,
                value: cat.id,
              })
            }
          })
        }
      });
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <Field 
          name='subject_id'
          label={formatMessage('cardSubject')}
          component={SelectFieldAnt}
          options={subjects.map(_i => ({title: _i.name, value: _i.id}))}
          validate={[required()]}
          className="create-dialog-form__group create-dialog-form__group--indent-bottom"
        />
        <Field 
          name='category_id'
          label={formatMessage('cardCategory')}
          component={TreeSelectField}
          tree={tree}
          validate={[required()]}
        />
        <Field name='is_show' label={formatMessage('cardQuestionShow')} component={SwitchField} />
        <div className="create-dialog-form__group flex" style={{justifyContent: 'center', marginTop: 20,
            flexDirection: 'row'}}>
           <button className="btn btn-primary" type="submit">{formatMessage('btnModalSaveCard')}</button>
        </div>
      </form>
    )
  }
}

const FormContentData = reduxForm({
  form: 'form_card_trashed',
  enableReinitialize: true,
})(FormContent);

const mapStateToProps = (state, ownProps) => ({
  valuesForm: getFormValues('form_card_trashed')(state),
})

const mapDispatchToProps = {
  updateCard,
  // hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContentData);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardTrashed/components/CardFormTrashed/components/FormContent/FormContent.jsx